// src/config.js
export const baseurl_node = process.env.REACT_APP_BASE_URL_NODE;